import { render, staticRenderFns } from "./Manage-Manufacturer.vue?vue&type=template&id=e9703b54&"
import script from "./Manage-Manufacturer.vue?vue&type=script&lang=js&"
export * from "./Manage-Manufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports